import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
// import VueAxios from 'vue-axios' //追記

Vue.config.productionTip = false

import Mixin from './mixin/mixin.js';
Vue.mixin(Mixin);

// Vue.use(VueAxios, axios) //追記

new Vue({
  router,
  store,
  vuetify,
  axios,
  render: h => h(App)
}).$mount('#app')
